import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MatDialog } from '@angular/material';
import { ProductDialogComponent } from './product-dialog/product-dialog.component';
import { AppService } from '../../app.service';
import { Parte } from '../../domain/parte';
import { GLOBAL } from '../../global';

@Component({
  selector: 'app-products-carousel',
  templateUrl: './products-carousel.component.html',
  styleUrls: ['./products-carousel.component.scss']
})
export class ProductsCarouselComponent implements OnInit {

  public urlBucket = GLOBAL.URL_BUCKET;
  public imagenDefecto = GLOBAL.IMAGEN_DEFECTO;

  @Input('products') products: Array<Parte> = [];
  public config: SwiperConfigInterface = {};
  constructor(public appService:AppService, public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
   }
  
  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 6,
      spaceBetween: 16,       
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,  
      breakpoints: {
        480: {
          slidesPerView: 1
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
        1500: {
          slidesPerView: 5,
        }
      }
    }
  }

  public openProductDialog(product){
    //console.log(product);   
    let dialogRef = this.dialog.open(ProductDialogComponent, {
        data: product,
        panelClass: 'product-dialog'
    });
  }

  public seeProduct(product){
    this.router.navigate(['/products/detail/' + product.partId]);
  }

}